import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["receipt"]
  static values = {
    text: String,
    trackUrl: String
  }

  connect() {
    this.element.dataset.shareMode = navigator.share ? "native" : "copy"
  }

  async send() {
    try {
      if (navigator.share) {
        await navigator.share({ text: this.textValue })
        await this.track()
        this.complete()
      } else {
        await this.writeText(this.textValue)
      }
    } catch (error) {
      if (error?.name === "AbortError") return

      await this.writeText(this.textValue)
    }
  }

  complete() {
    if (this.hasReceiptTarget) this.receiptTarget.classList.remove("hidden")
    this.dispatch("completed")
  }

  async track() {
    if (!this.hasTrackUrlValue) return

    try {
      await fetch(this.trackUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })
    } catch {
      // Sharing should still work when beta event tracking is unavailable.
    }
  }

  async writeText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text)
        return
      } catch {
        // Fall through to the temporary textarea path.
      }
    }

    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    textarea.remove()
  }
}
